/**
 * Утилита для получения информации о билде приложения
 */

export interface BuildInfo {
  branch: string;
  commit: string;
  commitFull: string;
  author: string;
  gitDate: string;
  buildDate: string;
  environment: string;
  mode: string;
  ciPipelineId: string;
  ciJobId: string;
}

/**
 * Получить информацию о билде приложения
 */
export const getBuildInfo = (): BuildInfo => {
  return {
    branch: process.env.REACT_APP_GIT_BRANCH || "unknown",
    commit: process.env.REACT_APP_GIT_COMMIT || "unknown",
    commitFull: process.env.REACT_APP_GIT_COMMIT_FULL || "unknown",
    author: process.env.REACT_APP_GIT_AUTHOR || "unknown",
    gitDate: process.env.REACT_APP_GIT_DATE || "unknown",
    buildDate: process.env.REACT_APP_BUILD_DATE || "unknown",
    environment: process.env.REACT_APP_ENV || "unknown",
    mode: process.env.NODE_ENV || "unknown",
    ciPipelineId: process.env.REACT_APP_CI_PIPELINE_ID || "local",
    ciJobId: process.env.REACT_APP_CI_JOB_ID || "local",
  };
};

/**
 * Проверить, является ли билд production
 */
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === "production";
};

/**
 * Проверить, является ли билд development
 */
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === "development";
};

/**
 * Получить версию из имени ветки (например, "release-2.13.0" -> "2.13.0")
 */
export const getVersionFromBranch = (): string | null => {
  const branch = process.env.REACT_APP_GIT_BRANCH || "";
  const match = branch.match(/release-(\d+\.\d+\.\d+)/);
  return match ? match[1] : null;
};

/**
 * Вывести информацию о билде в консоль (красиво оформленную)
 */
export const logBuildInfo = (): void => {
  const buildInfo = getBuildInfo();
  const isCI = buildInfo.ciPipelineId !== "local";

  console.log(
    "%c🚀 DealerPassport Build Info",
    "color: #4CAF50; font-size: 16px; font-weight: bold;"
  );
  console.log(
    "%c┌─────────────────────────────────────────────────",
    "color: #9E9E9E;"
  );
  console.log(
    `%c│ %cGit Branch:%c ${buildInfo.branch}`,
    "color: #9E9E9E;",
    "color: #2196F3; font-weight: bold;",
    "color: #fff;"
  );
  console.log(
    `%c│ %cCommit:%c ${buildInfo.commit}`,
    "color: #9E9E9E;",
    "color: #FF9800; font-weight: bold;",
    "color: #fff;"
  );
  console.log(
    `%c│ %cAuthor:%c ${buildInfo.author}`,
    "color: #9E9E9E;",
    "color: #9C27B0; font-weight: bold;",
    "color: #fff;"
  );
  console.log(
    `%c│ %cEnvironment:%c ${buildInfo.environment} (${buildInfo.mode})`,
    "color: #9E9E9E;",
    "color: #00BCD4; font-weight: bold;",
    "color: #fff;"
  );
  console.log(
    `%c│ %cBuild Date:%c ${new Date(buildInfo.buildDate).toLocaleString(
      "ru-RU"
    )}`,
    "color: #9E9E9E;",
    "color: #FFC107; font-weight: bold;",
    "color: #fff;"
  );

  // Показываем CI информацию только если билд был в CI/CD
  if (isCI) {
    console.log(
      `%c│ %cCI Pipeline:%c #${buildInfo.ciPipelineId}`,
      "color: #9E9E9E;",
      "color: #E91E63; font-weight: bold;",
      "color: #fff;"
    );
    console.log(
      `%c│ %cCI Job:%c #${buildInfo.ciJobId}`,
      "color: #9E9E9E;",
      "color: #3F51B5; font-weight: bold;",
      "color: #fff;"
    );
  }

  console.log(
    "%c└─────────────────────────────────────────────────",
    "color: #9E9E9E;"
  );

  // Добавляем buildInfo в window для доступа из devtools
  if (typeof window !== "undefined") {
    (window as any).__BUILD_INFO__ = buildInfo;
    console.log(
      "%cℹ️  Для просмотра полной информации введите: %cwindow.__BUILD_INFO__",
      "color: #607D8B;",
      "color: #4CAF50; font-weight: bold; background: #263238; padding: 2px 6px; border-radius: 3px;"
    );
  }
};
